import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { useCartItemsStyles } from '../hooks/useCartItemsStyles.';
import CartItem from './CartItem';
import CartItemGuest from './CartItemGuest';
import { actions as cartActions } from '../../../../store/ducks/cart.duck';
import ImageDialog from '../../../../components/ui/ImageDialog/imageDialog';
import { selectCart, selectGuestCart, selectIsAuthorized } from '../selectors';

export function CartItems() {
  const dispatch = useDispatch();
  const cart = useSelector(selectCart);
  const guestCart = useSelector(selectGuestCart);
  const isAuthorized = useSelector(selectIsAuthorized);
  const classes = useCartItemsStyles();
  const [isImageOpen, setImageOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  const handleImage = useCallback(
    (url: any) => {
      if (isImageOpen) {
        setImageUrl(null);
        setImageOpen(false);
      } else {
        setImageUrl(url);
        setImageOpen(true);
      }
    },
    [isImageOpen, imageUrl]
  );

  return (
    <>
      {imageUrl && <ImageDialog open={isImageOpen} handleClose={handleImage} url={imageUrl} />}
      <div className={classes.card}>
        <>
          {isAuthorized ? (
            <>
              {cart?.items.map((item, index) => (
                <CartItem
                  key={`${item.product.id}_${index}`}
                  isLastItem={index === cart.items.length - 1}
                  itemCart={item}
                  handleImage={handleImage}
                  setProductCount={data => dispatch(cartActions.setProductCountRequest(data))}
                />
              ))}
            </>
          ) : (
            <>
              {guestCart?.items.map((item, index) => (
                <CartItemGuest
                  key={`${item.product.id}_${index}`}
                  isLastItem={index === guestCart.items.length - 1}
                  itemGuestCart={item}
                  handleImage={handleImage}
                  setCountGuestCart={data => dispatch(cartActions.setCountGuestCart(data))}
                />
              ))}
            </>
          )}
        </>
      </div>
    </>
  );
}
